var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderOpenOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 8.67188H16.0156V6.45312C16.0156 6.10742 15.7363 5.82812 15.3906 5.82812H9.23828L6.94727 3.63672C6.91812 3.60943 6.87977 3.59409 6.83984 3.59375H1.875C1.5293 3.59375 1.25 3.87305 1.25 4.21875V15.7812C1.25 16.127 1.5293 16.4062 1.875 16.4062H15.5078C15.7617 16.4062 15.9922 16.252 16.0879 16.0156L18.7051 9.53125C18.7344 9.45703 18.75 9.37695 18.75 9.29688C18.75 8.95117 18.4707 8.67188 18.125 8.67188ZM2.65625 5H6.33789L8.67383 7.23437H14.6094V8.67188H4.64844C4.39453 8.67188 4.16406 8.82617 4.06836 9.0625L2.65625 12.5625V5ZM15.0645 15H3.10547L5.12305 10H17.084L15.0645 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpenOutline);
export default __webpack_public_path__ + "static/media/folder_open_outline.856e8767110dee68e84f730e38a440a9.svg";
export { ForwardRef as ReactComponent };